import type { SidenavItemConfig } from '@components/Sidenav/Sidenav.config';

export type StatsAnalyticsPlusAdItemProps = Pick<SidenavItemConfig, 'dataTest'>;

export enum ANALYTICS_PLUS_AD_MODAL_TRACK_EVENTS {
  BUTTON_SHOWN = 'analytics_plus_funnel_button_shown',
}
